export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            entity: 'Video',
            video_route: videoRoute(entity),
            video_title_full: videoTitleFull(entity),
            video_title_placing: videoTitlePlacing(entity),
            video_description: videoDescription(entity),
            video_excerpt: videoExcerpt(entity),
            video_preview_url: videoPreviewUrl(entity),
            video_thumb_url: videoThumbUrl(entity),
            video_image_url: videoImageUrl(entity),
            video_embed_url: videoEmbedUrl(entity),
            video_date_taken_long: videoDateTakenLong(entity),
            video_date_taken_short: videoDateTakenShort(entity),
            video_date_taken_tiny: videoDateTakenTiny(entity),
        };
    }

    async function get(idVideo) {
        let video = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('videos/' + idVideo);
            video = build(data.video);
        } catch (e) {
            error = useApiError(e);
        }
        return {video, error};
    }

    async function patch(idVideo, params) {
        let video = null,
            error = null;
        try {
            const {data} = await useApi('videos').patch('videos/' + idVideo, params);
            video = build(data.video);
        } catch (e) {
            error = useApiError(e);
        }
        return {video, error};
    }

    const $config = useRuntimeConfig().public;
    const UtilityDates = useUtilityDates();

    function videoRoute(entity) {
        if (!entity.id_video) return undefined;
        return {
            name: 'videos-idVideo',
            params: {
                idVideo: entity.id_video,
            },
        };
    }

    function videoTitleFull(entity) {
        if (!entity.video_title) return undefined;
        return (
            entity.video_title + ' | ' + (entity.video_dancer_names || entity.event_title || 'West Coast Swing Video')
        );
    }

    function videoTitlePlacing(entity) {
        if (!entity.video_title) return undefined;
        let title = entity.video_title;
        if (['1st', '2nd', '3rd'].includes(entity.video_placing)) {
            switch (entity.video_placing) {
                case '1st':
                    title = '🥇 ' + title;
                    break;
                case '2nd':
                    title = '🥈 ' + title;
                    break;
                case '3rd':
                    title = '🥉 ' + title;
                    break;
            }
        }
        return title;
    }

    function videoDescription(entity) {
        if (!entity.video_title) return undefined;
        let description = '';
        if (entity.video_dancer_names) {
            description += entity.video_dancer_names;
        }
        if (['1st', '2nd', '3rd', '4th', '5th'].indexOf(entity.video_placing) !== -1) {
            if (description) description += ' ';
            description += 'take ' + entity.video_placing + ' place in the';
        }
        if (entity.video_division && entity.video_format) {
            if (description) description += ' ';
            description += entity.video_division + ' ' + entity.video_format;
        }
        if (entity.event_slug && entity.event_title) {
            if (description) description += ' ';
            description += 'at ' + entity.event_title;
        }
        if (!description) {
            description += 'Video recorded ';
        }
        if (UtilityDates.printDateTime(entity.video_date_taken, 'longDate')) {
            if (description) description += ' ';
            description += 'on ' + UtilityDates.printDateTime(entity.video_date_taken, 'longDate');
        }
        if (!description) {
            description = 'View this video on the ' + $config.siteName + ' website.';
        } else {
            description += '.';
        }
        return description;
    }

    function videoExcerpt(entity) {
        if (!entity.video_title) return undefined;
        if (entity.video_dancers?.split(';').length > 1) return entity.video_dancer_names;
        if (entity.video_dancer_names) {
            let excerpt = '';
            if (entity.video_division) excerpt += entity.video_division;
            if (excerpt && entity.video_format) excerpt += ' ' + entity.video_format;
            if (excerpt) return excerpt;
        }
        if (entity.event_title) return entity.event_title;
        return null;
    }

    function videoPreviewUrl(entity) {
        if (!entity.video_preview) return null;
        return $config.videos + 'preview/' + encodeURIComponent(entity.video_preview);
    }

    function videoThumbUrl(entity) {
        if (!entity.video_youtube_id) return null;
        return `https://img.youtube.com/vi/${entity.video_youtube_id}/mqdefault.jpg`;
    }

    function videoImageUrl(entity) {
        if (!entity.video_youtube_id) return null;
        return `https://img.youtube.com/vi/${entity.video_youtube_id}/maxresdefault.jpg`;
    }

    function videoEmbedUrl(entity) {
        if (!entity.video_youtube_id) return null;
        return `https://www.youtube.com/embed/${entity.video_youtube_id}`;
    }

    function videoDateTakenLong(entity) {
        if (!entity.video_date_taken) return undefined;
        return UtilityDates.printDateTime(entity.video_date_taken, 'longDate');
    }

    function videoDateTakenShort(entity) {
        if (!entity.video_date_taken) return undefined;
        return UtilityDates.printDateTime(entity.video_date_taken, 'shortDate');
    }

    function videoDateTakenTiny(entity) {
        if (!entity.video_date_taken) return undefined;
        return UtilityDates.printDateTime(entity.video_date_taken, 'tinyDate');
    }

    return {get, patch, build};
}
